import React from 'react';
import WebPushSection from '../WebPushSection';

/**
 * PART 3, раздел 7: основной и единственный контрол Web Push живёт здесь.
 * Email и Telegram занимают место в архитектуре, но кнопок не получают —
 * канала без endpoint'а изображать рабочим нельзя.
 */
const ProfileNotificationsTab = () => (
  <div className="pp-card">
    <h2 className="pp-card-title">Уведомления</h2>

    <div className="pp-channel">
      <WebPushSection />
    </div>

    <div className="pp-channel">
      <div className="pp-channel-text">
        <span className="pp-channel-name">Email</span>
      </div>
      <span className="pp-chip">Скоро</span>
    </div>

    <div className="pp-channel">
      <div className="pp-channel-text">
        <span className="pp-channel-name">Telegram</span>
      </div>
      <span className="pp-chip">Скоро</span>
    </div>
  </div>
);

export default ProfileNotificationsTab;
